import React, { useEffect } from 'react'
import Header from './header'
import { useQueryClient } from 'react-query'
import { LayoutFooter, Lhs, TourGuide } from '../../components'
import { useGlobalStore } from '../../store'

import {
  PostLoginOuterWrapper,
  LhsWrapper,
  RhsWrapper,
  ContentWrapper,
  ContentInnerWrapper,
} from './style'
import { Box } from '@mui/material'

const PostLogin = (props) => {
  const { children } = props
  const { isTourGuideActive, showLhsMenu } = useGlobalStore()
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.clear()
  }, [])

  return (
    <PostLoginOuterWrapper>
      {isTourGuideActive && <TourGuide type='postLogin' />}
      <Header />
      <Box sx={{ display: 'flex' }}>
        <LhsWrapper>
          <Lhs />
        </LhsWrapper>
        <RhsWrapper showLhsMenu={showLhsMenu}>
          <ContentWrapper>
            <ContentInnerWrapper>{children}</ContentInnerWrapper>
            <LayoutFooter />
          </ContentWrapper>
        </RhsWrapper>
      </Box>
    </PostLoginOuterWrapper>
  )
}

export default PostLogin
